import type { ProcessedStatistic } from 'entities/Analytics'

export type Trend = NonNullable<ProcessedStatistic['trend']>

export const calculateTrend = (currentValue: number, prevValue: number): Trend => {
  if (prevValue === 0) {
    const isUp = currentValue > 0
    return {
      isUp,
      percent: 0,
      absolute: currentValue,
    }
  }

  const absolute = currentValue - prevValue
  const percent = Math.round((absolute / prevValue) * 100)
  const isUp = absolute > 0

  return {
    isUp,
    percent: Math.abs(percent),
    absolute: Math.abs(absolute),
  }
}
